export const DefaultBadge = {
  style: 'warning',
  text: 'None'
};

export const LoadingBadge = {
  style: 'default',
  text: 'Loading'
};


// WEBPACK FOOTER //
// src/helpers/badge.js